var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePodcasts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 48.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.26 186.32v27.351",
    stroke: "#0066d9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.74 186.32v27.351",
    stroke: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.13 104.27v89.46m0 74.645v27.351",
    stroke: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.87 206.26v89.46m0-191.46v27.351",
    stroke: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200 127.06v145.87m0-248.68v27.351m0 296.78v27.351",
    stroke: "#fab908"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePodcasts);
export default __webpack_public_path__ + "static/media/Google_Podcasts.87587f9b89066dd9f3c5f175b4da7552.svg";
export { ForwardRef as ReactComponent };